import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import { AppSettingsProvider } from "@britishcouncil/react-common";
import { nonceTemplate } from "utils/nonce.ts";
import { AppSettingsContext, DEFAULT_APP_SETTINGS } from "settings";
import { FullScreenError, FullScreenLoader } from "components";
import App from "./App.tsx";
import { theme } from "./theme";

const cache = createCache({
  key: "bc-entrynet",
  nonce: nonceTemplate,
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <CacheProvider value={cache}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <AppSettingsProvider
          defaultAppSettings={DEFAULT_APP_SETTINGS}
          Context={AppSettingsContext}
          loader={<FullScreenLoader text="One second, please..." />}
          error={<FullScreenError />}
        >
          <App />
        </AppSettingsProvider>
      </ThemeProvider>
    </CacheProvider>
  </StrictMode>
);
